module.exports = __webpack_public_path__ + "img/docLine.73546f4c.png";